var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"treat-section full-width"},[_c('treat-face-section'),_c('eye-contour-section'),_c('active-ingredients-mobile-selector-modal'),_c('ingredient-info-modal',{nativeOn:{"click":function($event){$event.stopPropagation();}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }